var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIconEmptyColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79572 1L16.59 14.5H1.00149L8.79572 1ZM7.9297 0.5C8.3146 -0.166667 9.27685 -0.166666 9.66175 0.5L17.456 14C17.8409 14.6667 17.3598 15.5 16.59 15.5H1.00149C0.231691 15.5 -0.249434 14.6667 0.135467 14L7.9297 0.5ZM8.14924 6.02192C8.14924 5.71742 8.39608 5.47058 8.70058 5.47058C9.00507 5.47058 9.25191 5.71742 9.25191 6.02192V6.11381C9.25191 6.41831 9.00507 6.66515 8.70058 6.66515C8.39608 6.66515 8.14924 6.41831 8.14924 6.11381V6.02192ZM8.14924 8.41105C8.14924 8.10655 8.39608 7.85971 8.70058 7.85971C9.00507 7.85971 9.25191 8.10655 9.25191 8.41105V12.6839C9.25191 12.9884 9.00507 13.2353 8.70058 13.2353C8.39608 13.2353 8.14924 12.9884 8.14924 12.6839V8.41105Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconEmptyColor);
export default __webpack_public_path__ + "static/media/warningIconEmptyColor.fc7f20f020ed75928597d5e09368cf43.svg";
export { ForwardRef as ReactComponent };